<template>
  <div>
    <ls-rangepicker
      :current_levelprofile = "current_levelprofile"
      :current_user = current_user
    ></ls-rangepicker>
    <v-data-table
      :headers="headers"
      :items="users"
      :items-per-page="-1"
      :loading="is_loading"
      hide-default-footer
    >
      <template v-slot:item.kentix_id="{ item }">
        <v-chip
          small
        >
          {{ item.kentix_id }}
        </v-chip>
      </template>
      <template v-slot:item.is_active="{ item }">
        <v-icon
          v-if="item.is_active"
          color="success"
        >
          mdi-check-circle
        </v-icon>
        <v-icon
          v-else
          color="error"
        >
          mdi-close-circle
        </v-icon>
      </template>
      <template v-slot:item.fullname="{ item }">
        <div
          v-if="fullname_edit.includes(item.kentix_id)"
        >
          <v-text-field
            dense
            v-model="item.fullname"
            append-icon="mdi-check"
            append-outer-icon="mdi-close"
            maxlength="90"
            @click:append="set_fullname_user(item.kentix_id, item.fullname); fullname_edit.splice(fullname_edit.indexOf(item.kentix_id), 1)"
            @keydown.enter="set_fullname_user(item.kentix_id, item.fullname); fullname_edit.splice(fullname_edit.indexOf(item.kentix_id), 1)"
            @click:append-outer="fullname_edit.splice(fullname_edit.indexOf(item.kentix_id))"
          >
          </v-text-field>
        </div>
        <div
          v-else
        >
          {{ item.fullname }}
          <v-btn
            v-if="can_manage(item.levelprofiles)"
            icon
            small
            @click="fullname_edit.push(item.kentix_id)"
          >
            <v-icon
              small
            >
              mdi-pencil
            </v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:item.levelprofiles="{ item }">
        <v-tooltip
          v-for="(levelprofile, index) in item.levelprofiles"
          :key="index"
          left
        >
          <template v-slot:activator="{ on }">
            <v-chip
              v-on="on"
              class="mr-1"
              small
              close
              :color="time_range_to_color(levelprofile.unlock_at, levelprofile.lock_at)"
              :disabled="!$store.getters.get_kentix_levelprofile(levelprofile.levelprofile_id).can_manage"
              @click:close="levelprofile_edit[item.kentix_id] = item.levelprofiles; delete_levelprofile_from_user(item.kentix_id, levelprofile.levelprofile_id)"
              @click="current_levelprofile = levelprofile; current_user = item"
              close-label="mdi-pencil"
            >
              {{ $store.getters.get_kentix_levelprofile(levelprofile.levelprofile_id).name }}
            </v-chip>
          </template>
          <div
            v-if="$store.getters.get_kentix_levelprofile(levelprofile.levelprofile_id).doorlocks.length == 0"
          >
            Diese Schließgruppe enthält keine Türen
          </div>
          <div
            v-else
          >
            Diese Schließgruppe enthält folgende Türen:
          </div>
          <div
            v-for="(doorlock, index) in $store.getters.get_kentix_levelprofile(levelprofile.levelprofile_id).doorlocks"
            :key="index"
          >
            - {{ $store.getters.get_kentix_device(doorlock).name }}
          </div>
        </v-tooltip>

        <v-menu
          offset-y
        >
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              icon
              small
              v-bind="attrs"
              v-on="on"
              :loading="item.kentix_id in levelprofile_edit && item.levelprofiles === levelprofile_edit[item.kentix_id]"
            >
              <v-icon
                small
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(levelprofile, index) in addable_levelprofiles"
              :key="index"
              link
              @click="levelprofile_edit[item.kentix_id] = item.levelprofiles; add_levelprofile_to_user(item.kentix_id, levelprofile.id)"
            >
              <v-list-item-title v-text="levelprofile.name"></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.is_ldap="{ item }">
        <v-icon
          v-if="item.is_ldap"
          color="success"
        >
          mdi-database-outline
        </v-icon>
        <v-icon
          v-else
        >
          mdi-database-off-outline
        </v-icon>
      </template>
      <template v-slot:item.emergency_access="{ item }">
        <v-icon
          v-if="item.emergency_access"
          color="warning"
        >
          mdi-lightning-bolt-outline
        </v-icon>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn
          v-if="item.is_active"
          icon
          @click="lock_edit.push(item.kentix_id); lock_user(item.kentix_id, item.fullname)"
        >
          <v-icon>
            mdi-lock
          </v-icon>
        </v-btn>
        <v-btn
          v-else
          icon
          @click="lock_edit.push(item.kentix_id); unlock_user(item.kentix_id, item.fullname)"
        >
          <v-icon
            color="success"
          >
            mdi-lock-open-variant
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import LsRangepicker from "./ls-rangepicker";
export default {
  name: "ls-manage",
  components: { LsRangepicker },
  data: () => ({
    current_levelprofile: null,
    current_user: null,
    fullname_edit: [],
    levelprofile_edit: {},
    lock_edit: [],
    headers: [
      { text: 'Aktiv', value: 'is_active', sortable: false },
      { text: 'Benutzer ID', value: 'kentix_id', sortable: true },
      //{ text: 'Quelle', value: 'is_ldap', sortable: false },
      { text: 'Name', value: 'fullname' },
      { text: 'Schließgruppen', value: 'levelprofiles' },
      { text: 'Transponder', value: 'rfid_uid', sortable: false },
      { text: 'Notfallzugang', value: 'emergency_access', sortable: false },
      { text: 'Sperren', value: 'action', sortable: false },
    ]
  }),
  methods: {
    time_range_to_color(unlock_at, lock_at){
      let color = ''
      if(unlock_at === null && lock_at === null){
        return color
      }
      if(unlock_at !== null){
        if(new Date(unlock_at) <= Date.now()){
          color = 'success'
        }
        else{
          color = 'error'
        }
      }
      if(lock_at !== null){
        if(new Date(lock_at) <= Date.now()){
          color = 'error'
        }
        else{
          color = 'success'
        }
      }
      return color
      //levelprofile.lock_at != null || levelprofile.unlock_at != null ? 'warning' : ''
    },
    set_fullname_user(user_id, fullname){
      this.$store.dispatch("update", { "payload_type": 'PUT', "context": "/kentix/user/" + user_id + "/fullname/" + fullname})
    },
    add_levelprofile_to_user(user_id, levelprofile_id){
      this.$store.dispatch("update", { "payload_type": 'PUT', "context": "/kentix/user/" + user_id + "/levelprofile/" + levelprofile_id})
    },
    delete_levelprofile_from_user(user_id, levelprofile_id){
      this.$store.dispatch("update", { "payload_type": 'DELETE', "context": "/kentix/user/" + user_id + "/levelprofile/" + levelprofile_id})
    },
    unlock_user(user_id, fullname){
      this.$store.state.general.dialogs.push({title: 'Benutzer entsperren', text: 'Du bist dabei, den Benutzer ' + fullname +' zu entsperren.',  btn_1_title: 'Abbrechen', btn_2_title: 'Entsperren', btn_2_update: { "payload_type": 'PUT', "context": "/kentix/user/" + user_id + "/unlock"}, btn_2_color: 'success', show: true})
    },
    lock_user(user_id, fullname){
      this.$store.state.general.dialogs.push({title: 'Benutzer sperren', text: 'Du bist dabei, den Benutzer ' + fullname +' zu sperren.',  btn_1_title: 'Abbrechen', btn_2_title: 'Sperren', btn_2_update: { "payload_type": 'PUT', "context": "/kentix/user/" + user_id + "/lock"}, btn_2_color: 'error', show: true})
    },
    can_manage(levelprofiles){
      return levelprofiles.every(lp => this.$store.state.kentix.levelprofiles_lut[lp.levelprofile_id].can_manage)
    }
  },
  computed: {
    addable_levelprofiles(){
      return Object.values(this.$store.state.kentix.levelprofiles_lut).filter(levelprofile => levelprofile.can_manage)
    },
    is_loading(){
      return this.$store.state.kentix.users == null || this.$store.state.kentix.devices == null || this.$store.state.kentix.levelprofiles == null
    },
    users(){
      let searchQuery = this.$store.state.general.global_search
      return this.is_loading ? [] : this.$store.state.kentix.users.filter((usr) => usr.fullname.toLowerCase().includes(searchQuery.toLowerCase()) || (""+usr.kentix_id).includes(searchQuery))
    }
  },
};
</script>

<style scoped>

</style>
